/*******************************************************************************
 * Project:
 * Summary:
 *      Define EnterKeyDirective class
 * Remarks:
 *      Set Enter key press behaves like a Tab
 * History:
 *      NguyenTV            2021/07/01    Create
 ******************************************************************************/
import { Directive, Input, ElementRef, HostListener, OnInit } from '@angular/core';
import { EnterKey, EnterKeyService } from '../../services/enter-key.service';

@Directive({
    selector: '[enterIndex]'
})
export class EnterKeyDirective implements OnInit {
    private _index: number;

    get index() {
        return this._index;
    }
    @Input('enterIndex')
    set index(i: any) {
        this._index = Number(i);
    }

    @HostListener('keydown', ['$event'])
    onInput(e: any) {
        if (e.which === 13) {
            e.preventDefault();
            if (e.shiftKey) {
                // shift + enter
                this.nextShiftEnterValue();
            } else {
                // enter
                this.nextEnterValue();
            }
        }
    }
    constructor(private el: ElementRef, private enterService: EnterKeyService) { }

    ngOnInit() {
        this.enterService.selectedInput.subscribe((item) => {
            if (item.idx === this.index) {
                if (this.el.nativeElement.disabled || this.el.nativeElement.getAttribute('readOnly') !== null) {
                    if (item.blnIsShift === true) {
                        this.nextShiftEnterValue();
                    } else {
                        this.nextEnterValue();
                    }
                } else {
                    this.el.nativeElement.focus();
                    if (this.el.nativeElement.children.length > 0) {
                        this.el.nativeElement.children[0].focus();
                    }
                }
            }
        });
    }

    nextShiftEnterValue() {
        const obj = new EnterKey();
        obj.idx = this.index - 1;
        obj.blnIsShift = true;
        this.enterService.selectedInput.next(obj);
    }

    nextEnterValue() {
        const obj = new EnterKey();
        obj.idx = this.index + 1;
        obj.blnIsShift = false;
        this.enterService.selectedInput.next(obj);
    }
}
